
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/series/[serieSlug]/subscriptions",
      function () {
        return require("private-next-pages/series/[serieSlug]/subscriptions.tsx");
      }
    ]);
  